import { RenewalFormTranslations } from '../types';

export const renewalForm: RenewalFormTranslations = {
  // Page Title
  title: "Renovación de Matrícula 2026/2027",
  subtitle: "Reserva la plaza de tu hijo/a para el próximo curso escolar. El período de renovación está abierto hasta el 17 de marzo.",

  // Alert Messages
  earlyBirdActive: "🎉 ¡Aprovecha el descuento de reserva anticipada! Reserva antes del 23 de febrero y ahorra 50€ por niño/a en la matrícula.",
  earlyBirdEnded: "El período de descuento de reserva anticipada ha finalizado (23 de febrero).",

  // Sections
  contactInfo: "Datos de Contacto",
  childrenInfo: "Niños/as a Matricular",
  paymentPreference: "Preferencia de Pago",
  optionalServices: "Servicios Adicionales de Interés",
  educationalCommitment: "Compromiso Educativo",
  pricingSummary: "Resumen de Costes",

  // Fields
  parentName: "Nombre del Padre/Madre/Tutor",
  email: "Correo Electrónico",
  phone: "Teléfono",
  childName: "Nombre del Niño/a",
  birthDate: "Fecha de Nacimiento",
  currentLevel: "Nivel Actual",
  renewalLevel: "Nivel para 2026/2027",
  isCurrentStudent: "Esta niña/o está actualmente matriculada/o en Gándara",
  isCurrentStudentHelper: "Desmarca esta casilla si es una hermana/o nueva/o que no está actualmente en el centro",
  comments: "Comentarios o Consultas",
  commentsPlaceholder: "¿Tienes alguna pregunta o circunstancia especial que quieras compartir con nosotros?",

  // Levels
  levels: {
    infantil3: "Infantil 3 años",
    infantil4: "Infantil 4 años",
    infantil5: "Infantil 5 años",
    primary1: "Primaria - 1º",
    primary2: "Primaria - 2º",
    primary3: "Primaria - 3º",
    primary4: "Primaria - 4º",
    primary5: "Primaria - 5º",
    primary6: "Primaria - 6º",
    // Simplified for 2026-2027
    infantil: "Infantil (3 a 6 años)",
    primary: "Primaria C1 (6 a 8 años)",
    primaryC2: "Primaria C2 (9 a 11 años)"
  },

  // Payment
  paymentMonthly: "Pago Mensual (10 pagos)",
  paymentAnnual: "Pago Anual (1 pago)",
  annualSavings: "Ahorra 200€ por niño/a con el pago anual",

  // Services
  transport: "Transporte",
  transportPricing: "225€/mes ida y vuelta (mínimo 4 plazas)",
  comedor: "Comedor",
  comedorPricing: "195€/mes 5 días · 125€ 3 días · 90€ 2 días · 15€ día suelto",
  aulaMadruga: "Aula Madruga",
  aulaMadrugaPricing: "75€/mes por familia (desde las 8:15)",
  servicesNote: "Los precios mostrados son informativos. La contratación de servicios adicionales se gestiona por separado.",

  // Commitment
  commitmentTitle: "Compromiso Educativo 2026/2027",
  commitmentText: `Las personas abajo firmantes manifiestan que la relación familia - escuela se regirá por un espíritu de colaboración mutua y confianza para contribuir e incidir conjuntamente en la educación y formación de los niños y niñas. Y para ello manifiestan conocer que:

1. Gándara International School (GIS) es un centro docente extranjero, autorizado por la Xunta de Galicia y acreditado como escuela internacional por la NEASC (New England Association of Schools and Colleges) para el segundo ciclo de Educación Infantil y para la etapa de Educación Primaria. Su oferta es la enseñanza privada en su centro de Gondomar, situado en el Lugar de Moureira, número 1, parroquia de Mañufe, y basado en una pedagogía activa y vivencial.

2. La duración del presente compromiso comprende el curso escolar 2026/2027, empezando dicho curso el 1 de septiembre del año 2026. Dicha duración podrá ser objeto de RENOVACIÓN anualmente cuando se abra el proceso de reserva de plaza, siempre y cuando exista consentimiento expreso y escrito otorgado por los padres del niño/a y por el propio Centro.

3. El programa y plan de estudios del centro estará regido por el Calendario Escolar de la Comunidad Autónoma de Galicia.

4. El Centro se regirá por las Normas del Plan Convivencia, Plan de Protección del Menor, el Reglamento de Régimen Interior y demás políticas internas del centro.

5. Las familias deberán transmitir información veraz y completa sobre el hijo/a en el proceso de admisión, sobre todo en los aspectos relativos a la salud de los mismos así como alergias, intolerancias y toda información que pueda ser de relevancia para un adecuado desarrollo del menor.

6. Al no contar el centro con un equipo multidisciplinar para ACNEAE, en el caso de que surjan esas NEAE, los progenitores/tutores se comprometen a proporcionar una evaluación externa con especialistas apropiados y/o apoyo específico mediante terapias externas. Asimismo, los diagnósticos, tratamientos e informes que sean emitidos por los terapeutas externos, deberán ser trasladados al centro con el fin de poder trabajar en colaboración con estos gabinetes y lograr evoluciones favorables. El centro se reserva el derecho de no estar de acuerdo con la línea pedagógica seguida por el gabinete elegido por los progenitores/tutores.

7. En caso de incumplimiento de este compromiso así como de las demás normas publicadas en la web del centro y a disposición de todos los padres/tutores, éste podrá ser resuelto por el Centro teniendo como posibilidad la no renovación de la plaza para el curso siguiente y/o adoptar las medidas que se recogen expresamente en cada supuesto.`,
  commitmentAccept: "He leído y acepto el Compromiso Educativo para el curso 2026/2027",

  // Privacy
  privacyAccept: "He leído la información sobre protección de datos",

  // Pricing Summary
  summaryTitle: "Tu Resumen de Costes",
  summaryMatricula: "Matrícula",
  summaryMonthly: "Mensualidad",
  summaryAnnual: "Anual",
  summaryEarlyBird: "Descuento matrícula anticipada",
  summaryAnnualDiscount: "Descuento pago anual",
  summaryTotal: "Total Anual (10 meses)",
  summaryGrandTotal: "TOTAL A PAGAR",
  summaryNote: "Los servicios adicionales no están incluidos en el total",
  summaryPerMonth: "x 10 meses",
  summaryPerYear: "año",
  // Payment timing clarity
  summaryPayNow: "A Pagar Ahora (transferencia bancaria)",
  summaryBankTransferNote: "Realizar transferencia en agosto antes del inicio del curso",
  summaryPayDuringYear: "Pagos Durante el Curso Escolar",
  summaryMonthlyPayments: "Mensualidades (sept-junio)",
  summaryMonthlyBreakdown: "10 pagos mensuales de septiembre a junio",
  summaryPayAnnual: "Pago Anual (septiembre)",
  summaryAnnualBase: "Total anual",
  summaryAnnualTotal: "Total con descuento",
  summaryAnnualNote: "Pago único en septiembre",
  siblingLabels: {
    first: "1er hermano/a",
    second: "2º hermano/a",
    third: "3º+ hermano/a"
  },

  // Buttons
  addChild: "Añadir Otro Hijo/a",
  removeChild: "Eliminar",
  submit: "Confirmar Renovación",
  submitting: "Enviando...",

  // Messages
  success: "¡Renovación confirmada! Redirigiendo a la página de confirmación...",
  error: "Error al enviar la renovación. Por favor, inténtalo de nuevo o contacta con nosotros.",
  suggestedLevel: "Según la fecha de nacimiento, sugerimos el nivel:",
  allChildrenNewWarning: "Has marcado todos los niños/as como nuevos estudiantes. ¿Es esto correcto? Los estudiantes nuevos tienen un precio diferente al de renovación.",

  // Validation
  required: "Este campo es obligatorio",
  invalidEmail: "El correo electrónico no es válido",
  invalidPhone: "El teléfono debe tener al menos 9 dígitos",
  invalidDate: "La fecha no es válida",
  futureDateError: "La fecha de nacimiento no puede ser futura",
  oldDateWarning: "Esta fecha sugiere una edad de {age} años. Por favor, confirma que es correcta.",
  atLeastOneChild: "Debes añadir al menos un niño/a"
};
